window.JustCancelConfirmation = (function() {
    window.dataLayer = window.dataLayer || [];

    let self = {
        urls: {
            redirectUrl: '/my-health-insurance/manage-my-plan',
            removeJustPolicyCancelSession: '/api/sitecore/PolicyCancellation/RemoveJustPolicyCancelSession'
        },
        func: {
            init: function() {
                self.func.bindings();
            },
            bindings: function () {
                const previousPageUrl = document.referrer;
                const url = window.location.href;
                if (url.includes('/request-submitted') && !previousPageUrl.includes('/just-cancel')) {
                    window.location.href = self.urls.errorPageUrl;
                }
                $('#just-cancellation-button').on('click', self.func.removeSessionAndRedirect);
            },
            removeSessionAndRedirect: function () {
                $.post(self.urls.removeJustPolicyCancelSession)
                    .done(function () {
                        window.location.href = self.urls.redirectUrl;
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function() {
    if ('just-cancellation-section' === $('#just-cancellation-section').data('feature')) {
        window.JustCancelConfirmation.Init();
    }
});
